import { makeStyles, Theme } from "@material-ui/core/styles";

export function useCustomPaginationStyles() {
    const useStyles = makeStyles((theme: Theme) => ({
        main: {
            display: "flex",
            marginTop: 20,
        }
    }));
    const classes = useStyles();

    return {
        classes,
    };
}